/**
 * ExtrasListHeader - Dedicated header for extras list
 *
 * Matches the grid layout from extrasItem.css.ts:
 * gridTemplateColumns: '70px minmax(200px, 1fr) 220px 130px 140px 48px'
 */

import { Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './ExtrasListHeader.css';

export const ExtrasListHeader = () => {
  return (
    <Row className={styles.header}>
      <Typography variant="body" size="small" fontWeight="medium">
        Name
      </Typography>

      {/* Access methods column - 220px */}
      <Typography variant="body" size="small" fontWeight="medium">
        Access
      </Typography>

      {/* Type badge column - 130px */}
      <Typography variant="body" size="small" fontWeight="medium">
        Type
      </Typography>

      {/* Primary action column - 140px */}
      <div />

      {/* Dropdown menu column - 48px */}
      <div />
    </Row>
  );
};
